// Step 10 — Meetplan (T22). AI vertaalt de TOC uit Stap 9 naar een concreet
// meetplan: per effect indicatoren + bijbehorende vragen + schalen.
//
// Voor MVP/design-preview: mock-meetplan dat overeenkomt met de mock-TOC uit
// Stap 9. In productie: gegenereerd door T20 generateInitialTOC die ook
// indicators uitwerkt.
//
// Op submit: schrijft `OnboardingStatus.lastStep:11` op CompagnyMeta.

import { useContext, useMemo, useState } from 'react'

import { OnboardingFlow as OnboardingFlowContext } from '../../../StateManagment/OnboardingFlow'
import { db } from '../../../firebase/config'
import useDevPreview from '../../../hooks/useDevPreview'

// Mock — wordt vervangen door echte AI-output in T20.
const buildMockMeasurementPlan = () => ([
    {
        effect: 'Verbeterde zelfredzaamheid',
        indicators: [
            { name: 'Mate van eigen regie', scale: '1–5 schaal' },
            { name: 'Vertrouwen in eigen kunnen', scale: '1–5 schaal' },
        ],
    },
    {
        effect: 'Toegenomen werknemersvaardigheden',
        indicators: [
            { name: 'CV-kwaliteit', scale: 'beoordeling door coach' },
            { name: 'Sollicitatievaardigheid', scale: '1–5 schaal' },
            { name: 'Aantal positieve sollicitatiegesprekken', scale: 'absoluut aantal' },
        ],
    },
    {
        effect: 'Gegroeid sociaal netwerk',
        indicators: [
            { name: 'Aantal nieuwe contacten in werksfeer', scale: 'absoluut aantal' },
        ],
    },
])

const Step10MeasurementPlan = ({ onNext, onPrev }) => {

    const { compagnyId } = useContext(OnboardingFlowContext)
    const { active: devPreview } = useDevPreview()

    const plan = useMemo(() => buildMockMeasurementPlan(), [])

    const [advancing, setAdvancing] = useState(false)
    const [error, setError] = useState('')

    const accept = async () => {
        setError('')

        if (devPreview) {
            onNext()
            return
        }

        if (!compagnyId) {
            onNext()
            return
        }

        setAdvancing(true)
        try {
            const metaSnap = await db.collection('CompagnyMeta')
                .where('CompagnyID', '==', compagnyId)
                .limit(1)
                .get()

            if (!metaSnap.empty) {
                await metaSnap.docs[0].ref.update({
                    OnboardingStatus: { lastStep: 11, completed: false },
                })
            }
            onNext()
        } catch (err) {
            console.error('Step10MeasurementPlan accept error', err)
            setError(err.message || 'Er ging iets mis. Probeer het opnieuw.')
            setAdvancing(false)
        }
    }

    return (
        <div className="onboarding-step">
            <h1>Je meetplan in concept</h1>
            <p className="onboarding-step-intro">
                Op basis van je Theory of Change hebben we per effect indicatoren
                voorgesteld. Pas later in je meetplan aan wat je wilt — voor nu kijken
                we of de richting klopt.
            </p>

            <div className="onboarding-measurement-plan">
                {plan.map((entry, idx) => (
                    <section key={idx} className="onboarding-measurement-effect">
                        <h2>{entry.effect}</h2>
                        <ul>
                            {entry.indicators.map((ind, i) => (
                                <li key={i}>
                                    <strong>{ind.name}</strong>
                                    <span className="onboarding-measurement-scale">{ind.scale}</span>
                                </li>
                            ))}
                        </ul>
                    </section>
                ))}
            </div>

            {devPreview && (
                <p className="onboarding-step-stub-note">
                    Dev-preview: bovenstaand meetplan is mock-data. In productie genereert
                    T20 (generateInitialTOC) de indicatoren live op basis van je TOC.
                </p>
            )}

            {error && <p className="onboarding-error">{error}</p>}

            <div className="onboarding-step-actions">
                <button
                    type="button"
                    className="onboarding-button-secondary"
                    onClick={onPrev}
                    disabled={advancing}
                >
                    Terug
                </button>
                <button type="button" onClick={accept} disabled={advancing}>
                    {advancing ? <span className="onboarding-button-spinner" aria-label="Bezig" /> : 'Accepteer en ga door'}
                </button>
            </div>
        </div>
    )

}

export default Step10MeasurementPlan
